import { Card } from "antd";
import React from "react";
import { Datatable } from "../../components/functional";
import { reportProps } from "../../interfaces/interfaces";
import { ReportTableColumns } from "../../utils/tables/columns";
import { reportListData } from "../../utils/data";

export const ReportPage = () => {
  return (
    <Card bordered hoverable className="card overflow_x">
      <Datatable<reportProps>
        columns={ReportTableColumns}
        data={reportListData}
      />
    </Card>
  );
};
